import { Breakpoints } from '@angular/cdk/layout';
const breakpoints = [Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium];
export default breakpoints;

const smallBreakpoints = [Breakpoints.XSmall];
export { smallBreakpoints };
